import { SIMPLE_HI } from "./simple";

export const hi = {
  ...SIMPLE_HI,
  "Dashboard": "डैशबोर्ड",
  "Daily Reports": "दैनिक रिपोर्ट",
  "Business": "बिज़नेस",
  "Lottery": "लॉटरी",
  "Bank": "बैंक",
  "Reports": "रिपोर्ट्स",
  "Settings": "सेटिंग्स",
  "Gas Reports": "गैस रिपोर्ट",
  "Start Daily Report": "दैनिक रिपोर्ट शुरू करें",
  "Cash Transactions": "कैश लेन-देन",
  "Inventory": "इन्वेंटरी",
  "Lotto Reports": "लोट्टो रिपोर्ट",
  "Business Reports": "बिज़नेस रिपोर्ट",
  "Gas Daily Report": "गैस दैनिक रिपोर्ट",
  "Gas Sales Report": "गैस बिक्री रिपोर्ट",
  "Gas Variance Report": "गैस अंतर रिपोर्ट",
  "Gas Inventory": "गैस इन्वेंटरी",
  "Gas Settings": "गैस सेटिंग्स",
  "Invoices": "इनवॉइस",
  "Vendors": "वेंडर",
  "Categories": "श्रेणियाँ",
  "Payroll": "पेरोल",
  "Customers": "ग्राहक",
  "Other Income": "अन्य आय",
  "ATM Deposit": "ATM जमा",
  "Ownership": "स्वामित्व",
  "Lotto Sales Report": "लोट्टो बिक्री रिपोर्ट",
  "Books in Stock": "स्टॉक में बुक्स",
  "All Books Received": "प्राप्त सभी बुक्स",
  "Active Inventory": "सक्रिय इन्वेंटरी",
  "Books Sold": "बिकी हुई बुक्स",
  "Game Information": "गेम जानकारी",
  "Sales Report": "बिक्री रिपोर्ट",
  "Shift Reports": "शिफ्ट रिपोर्ट",
  "Weekly Reports": "साप्ताहिक रिपोर्ट",
  "Monthly Reports": "मासिक रिपोर्ट",
  "Yearly Reports": "वार्षिक रिपोर्ट",
  "Cash Shift Reports": "कैश शिफ्ट रिपोर्ट",
  "All Activity Reports": "सभी गतिविधि रिपोर्ट",
  "Store Settings": "स्टोर सेटिंग्स",
  "User Settings": "यूज़र सेटिंग्स",
  "User Role Settings": "यूज़र रोल सेटिंग्स",
  "Billing": "बिलिंग",
  "Home": "होम",
  "Shift": "शिफ्ट",
  "Scan": "स्कैन",
  "Report": "रिपोर्ट",
  "Menu": "मेनू",
  "Start Shift": "शिफ्ट शुरू करें",
  "Add Inventory": "इन्वेंटरी जोड़ें",
  "Scan Tickets": "टिकट स्कैन करें",
  "Activation": "एक्टिवेशन",
  "Confirm Sold": "बिक्री की पुष्टि",
  "Returned Books": "वापस की गई बुक्स",
  "Lotto Report": "लोट्टो रिपोर्ट",
  "Business Report": "बिज़नेस रिपोर्ट",
  "Gas Daily Reports": "गैस दैनिक रिपोर्ट",
  "Back": "पीछे",
  "Next": "आगे",
  "Save Report": "रिपोर्ट सेव करें",
  "Save & Finalize Shift": "सेव करें और शिफ्ट पूरी करें",
  "Print / Text Snapshot": "प्रिंट / टेक्स्ट स्नैपशॉट",
  "Save": "सेव",
  "Cancel": "रद्द करें",
  "Add": "जोड़ें",
  "Delete": "हटाएँ",
  "Save Settings": "सेटिंग्स सेव करें",
  "Sign out": "साइन आउट",
  "Change shift / date": "शिफ्ट / तारीख बदलें",
  "Shift Date": "शिफ्ट तारीख",
  "Select Shift": "शिफ्ट चुनें",
  "Finalized": "पूर्ण",
  "Open": "खुली",
  "Lottery Shift": "लॉटरी शिफ्ट",
  "Business Shift": "बिज़नेस शिफ्ट",
  "Note": "नोट",
  "Amount": "राशि",
  "Customer Name": "ग्राहक का नाम",
  "Type": "प्रकार",
  "Search…": "खोजें…",
  "Action": "क्रिया",
  "Status": "स्थिति",
  "Total": "कुल",
  "Date": "तारीख",
  "Total Lotto Sales": "कुल लोट्टो बिक्री",
  "Report Cash Balance": "रिपोर्ट कैश बैलेंस",
  "Cash On Hand": "हाथ में कैश",
  "Over / Short": "ज़्यादा / कम",
  "Over/Short": "ज़्यादा/कम",
  "Online Report": "ऑनलाइन रिपोर्ट",
  "Report Amount": "रिपोर्ट राशि",
  "Last Shift $": "पिछली शिफ्ट $",
  "Current Shift $": "इस शिफ्ट $",
  "Net Sales": "नेट बिक्री",
  "Online Cashing": "ऑनलाइन कैशिंग",
  "Balance": "बैलेंस",
  "Instant Cashing": "इंस्टेंट कैशिंग",
  "Cash Reconciliation": "कैश मिलान",
  "Total Sales (1+2)": "कुल बिक्री (1+2)",
  "Less: Total Cashing": "घटाएँ: कुल कैशिंग",
  "Less: Total Cash Paid Out": "घटाएँ: कुल कैश भुगतान",
  "Add: Other Cash Receipts": "जोड़ें: अन्य कैश प्राप्तियाँ",
  "Total Customer Paid Back": "ग्राहक द्वारा वापसी",
  "Total Customer Credits": "ग्राहक उधार",
  "Cash On Hand (counted)": "हाथ में कैश (गिनी हुई)",
  "Instant Report · Active Inventory": "इंस्टेंट रिपोर्ट · सक्रिय इन्वेंटरी",
  "Online Report · Total": "ऑनलाइन रिपोर्ट · कुल",
  "Instant Balance · Inactive Inventory": "इंस्टेंट बैलेंस · निष्क्रिय इन्वेंटरी",
  "Customer Transactions": "ग्राहक लेन-देन",
  "Less: Inventory Returned": "घटाएँ: वापस इन्वेंटरी",
  "Online Sales (2)": "ऑनलाइन बिक्री (2)",
  "Cashes": "कैशिंग",
  "Paid Back": "वापस भुगतान",
  "Credit Given": "उधार दिया",
  "Shifts on this day": "इस दिन की शिफ्टें",
  "Shift Check": "शिफ्ट जाँच",
  "No mistakes found – this shift looks clean.": "कोई गलती नहीं मिली – यह शिफ्ट सही लगती है।",
  "Fix": "सुधारें",
  "Sales Entry": "बिक्री एंट्री",
  "Shift Detail": "शिफ्ट विवरण",
  "Sales": "बिक्री",
  "Per POS report": "POS रिपोर्ट अनुसार",
  "Collected": "वसूल",
  "Sales Tax": "सेल्स टैक्स",
  "Refund": "रिफंड",
  "Credit Card Per POS": "POS अनुसार क्रेडिट कार्ड",
  "Other/Checks Per POS": "POS अनुसार अन्य/चेक",
  "Cash Per POS": "POS अनुसार कैश",
  "Credit Cards Collected": "क्रेडिट कार्ड वसूल",
  "Other/Checks Collected": "अन्य/चेक वसूल",
  "Customer Credit": "ग्राहक उधार",
  "Gross Sales": "सकल बिक्री",
  "Total Per POS": "POS अनुसार कुल",
  "Total Collected": "कुल वसूल",
  "Gross Sales (Net + Tax + Refund)": "सकल बिक्री (नेट + टैक्स + रिफंड)",
  "Total Sales Per POS": "POS अनुसार कुल बिक्री",
  "Add: Customer Credit": "जोड़ें: ग्राहक उधार",
  "Balance Per Report": "रिपोर्ट अनुसार बैलेंस",
  "Total Collected (Cash + CC + Other)": "कुल वसूल (कैश + कार्ड + अन्य)",
  "Started On": "शुरू हुआ",
  "Started By": "शुरू करने वाला",
  "Ended On": "समाप्त हुआ",
  "Finalized By": "पूर्ण करने वाला",
  "Add New Inventory": "नई इन्वेंटरी जोड़ें",
  "Scan the book barcode": "बुक का बारकोड स्कैन करें",
  "Add new game": "नई गेम जोड़ें",
  "New Inventory Received This Shift": "इस शिफ्ट में प्राप्त नई इन्वेंटरी",
  "Books Received": "प्राप्त बुक्स",
  "Inventory Value": "इन्वेंटरी मूल्य",
  "Game Number": "गेम नंबर",
  "Book Serial Number": "बुक सीरियल नंबर",
  "Game Name": "गेम का नाम",
  "Ticket Amount": "टिकट कीमत",
  "Ticket Qty": "टिकट संख्या",
  "Book Amount": "बुक राशि",
  "Received Date": "प्राप्ति तारीख",
  "Book Status": "बुक स्थिति",
  "Scan Instant Tickets": "इंस्टेंट टिकट स्कैन करें",
  "Confirm Books Activated": "एक्टिवेट बुक्स की पुष्टि",
  "Confirm Books Sold": "बिकी बुक्स की पुष्टि",
  "Returned Books · Back to the Lottery": "वापस बुक्स · लॉटरी को वापस",
  "Scan the book being returned": "वापस की जा रही बुक स्कैन करें",
  "Books Returned This Shift": "इस शिफ्ट में वापस बुक्स",
  "Return to lottery": "लॉटरी को वापस करें",
  "Store Information": "स्टोर जानकारी",
  "Store Modules": "स्टोर मॉड्यूल",
  "Store Logo": "स्टोर लोगो",
  "Live Data Sync": "लाइव डेटा सिंक",
  "Lottery Terminals": "लॉटरी टर्मिनल",
  "Nightly Email Snapshot": "रात्रि ईमेल स्नैपशॉट",
  "Store Users": "स्टोर यूज़र",
  "Store Name": "स्टोर नाम",
  "Address": "पता",
  "City": "शहर",
  "State": "राज्य",
  "Zip Code": "ज़िप कोड",
  "Website": "वेबसाइट",
  "Week starts on": "सप्ताह शुरू होता है",
  "Store sells Lottery": "स्टोर लॉटरी बेचता है",
  "Store sells Gas": "स्टोर गैस बेचता है",
  "Store has ATM": "स्टोर में ATM है",
  "Language": "भाषा",
  "Business Sales": "बिज़नेस बिक्री",
  "Lottery Sales": "लॉटरी बिक्री",
  "Merchandise Purchased": "माल खरीद",
  "Expenses": "खर्च",
  "Invoices Due": "बकाया इनवॉइस",
  "Top Vendors": "प्रमुख वेंडर",
  "Purchases by Category": "श्रेणी अनुसार खरीद",
  "Sales vs Purchases (by day)": "बिक्री बनाम खरीद (दिन अनुसार)",
  "This Month": "इस महीने",
  'Bank Deposit': 'बैंक जमा',
  'Checks': 'चेक',
  'Write a check': 'चेक लिखें',
  'Check register': 'चेक रजिस्टर',
  'Account check setup': 'खाता चेक सेटअप',
  'Store Users': 'स्टोर यूज़र',
  'Add User to Store': 'स्टोर में यूज़र जोड़ें',
  'First Name': 'पहला नाम',
  'Middle Name': 'मध्य नाम',
  'Last Name': 'उपनाम',
  'Mobile': 'मोबाइल',
  'Email (login)': 'ईमेल (लॉगिन)',
  'Password': 'पासवर्ड',
  'Role': 'भूमिका',
  'Select User': 'यूज़र चुनें',
  'Name': 'नाम',
  'Login / Email': 'लॉगिन / ईमेल',
  'Phone': 'फ़ोन',
  'Send Email': 'ईमेल भेजें',
  'Week Starts On': 'सप्ताह शुरू होता है',
  'Instant ticket numbering starts at': 'इंस्टेंट टिकट नंबर शुरू होता है',
  'New Terminal Nickname': 'नया टर्मिनल नाम',
  'Terminal': 'टर्मिनल',
  'Lottery Vending Machine': 'लॉटरी वेंडिंग मशीन',
  'Single lottery shift per day': 'दिन में एक ही लॉटरी शिफ्ट',
  'Over/short alert threshold ($)': 'ज़्यादा/कम चेतावनी सीमा ($)',
  'Owner WhatsApp number': 'मालिक का WhatsApp नंबर',
  'Subscription details': 'सब्सक्रिप्शन विवरण',
  'Subscription history': 'सब्सक्रिप्शन इतिहास',
  'Payment history': 'भुगतान इतिहास',
  'Current plan': 'वर्तमान प्लान',
  'Days left': 'बाकी दिन',
  'Plan': 'प्लान',
  'From': 'से',
  'To': 'तक',
  'Paid on': 'भुगतान तिथि',
  'Settings saved': 'सेटिंग्स सेव हो गईं',
  'Report saved': 'रिपोर्ट सेव हो गई',
  'Lottery shift finalized': 'लॉटरी शिफ्ट पूरी हुई',
  'Business shift finalized': 'बिज़नेस शिफ्ट पूरी हुई',
  'Send to owner on WhatsApp': 'मालिक को WhatsApp पर भेजें',
  'Read from photo': 'फ़ोटो से पढ़ें',
  'Reading…': 'पढ़ रहा है…',
  'Undo': 'पूर्ववत',
  'Books Returned This Shift': 'इस शिફ્ટ में वापस बुक्स',
  'Value Returned': 'वापस मूल्य',
  'Tickets Returned': 'वापस टिकट',
  'Print / Text Snapshot (full day)': 'प्रिंट / टेक्स्ट स्नैपशॉट (पूरा दिन)',
  'Overview': 'सारांश',
  'Books': 'बुक्स',
  'Games': 'गेम्स',
  'Money': 'पैसा',
  'Scan new books': 'नई बुक्स स्कैन करें',
  'Activate a book': 'बुक एक्टिवेट करें',
  'Return a book': 'बुक वापस करें',
  'Add a game': 'गेम जोड़ें',
  'Selling now': 'अभी बिक रहा है',
  'Running low': 'स्टॉक कम',
  'Best sellers · last 7 days': 'सबसे ज़्यादा बिकने वाले · पिछले 7 दिन',
  'In stock': 'स्टॉक में',
  'Activated': 'एक्टिवेटेड',
  'Sold': 'बिक गई',
  'All books': 'सभी बुक्स',
  'Pay employee': 'कर्मचारी को भुगतान',
  'Record other income': 'अन्य आय दर्ज करें',
  'In stock by price': 'कीमत के अनुसार स्टॉक',
  'books': 'बुक्स',
  'All games': 'सभी गेम्स',
  'Books on the shelf': 'शेल्फ पर बुक्स',
  'Value left to sell': 'बेचने के लिए बची कीमत',
};
